import React, { Component } from "react";
import * as pr from "../../common/PrimeComponents";
import * as Log from "../../common/Feedback/Log";
import * as Format from "../../common/FormatFunctions";

export class BPMPartProductJson extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: null,
      errors: [],
      currentListProperty: { name: "", quantity: "" }
    };

    this.logger = Log;
  }

  nullCheckList = currentList => {
    if (currentList === undefined || currentList === null) {
      currentList = [];
    } else {
    }

    return currentList;
  };
  addAcceptedProperty = () => {
    var property = this.state.currentListProperty;

    var currentList = this.nullCheckList(this.props.listProperties);

    if (this.props.defaults === true) {
      currentList.splice(currentList.length - 2, 0, property);
    } else {
      currentList.push(property);
    }

    this.logger.info(currentList);
    this.props.updateBean(this.props.listField, currentList);
    this.setState({ currentListProperty: { name: "", quantity: "" } });
  };

  removeAcceptedProperty = value => {
    var currentList = this.nullCheckList(this.props.listProperties);

    if (Format.isNotNull(currentList)) {
      this.logger.info(value);
      //   if (this.props.type === "DROPDOWN") {
      //     this.props.selectionOptions.forEach(element => {
      //       if (element.value === value.name) {
      //         value = element.label;
      //       }
      //     });
      //   }
      currentList = currentList.filter(item => item !== value);
    }

    this.logger.info(currentList);
    this.props.updateBean(this.props.listField, currentList);
    this.setState({ currentListProperty: { name: "", quantity: "" } });
  };

  render() {
    return (
      <div className="ui-g-12 card">
        {this.props.title}
        <div className="ui-g-12">
          <div className="ui-g-4">
            {/* <label>{this.props.header}</label> */}
            {this.getInputType()}
          </div>
          <div className="ui-g-4">
            <pr.InputText
              style={{ width: "100%" }}
              placeholder={"Quantity"}
              value={this.state.currentListProperty.quantity || ""}
              onChange={e => this.setValue("quantity", e.target.value)}
            />
          </div>
          <div className="ui-g-4">
            <pr.Button
              icon="pi pi-plus"
              onClick={() => {
                this.addAcceptedProperty();
              }}
              style={{ marginRight: ".25em", background: "green" }}
            />
          </div>
        </div>
        <div className="ui-g-12">{this.getCustomValuesTable()}</div>
      </div>
    );
  }

  getInputType = () => {
    if (this.props.type === "DROPDOWN") {
      this.logger.info(this.props.selectionOptions);
      return (
        <pr.Dropdown
          value={this.state.currentListProperty.name || ""}
          placeholder={"Selection"}
          options={this.props.selectionOptions}
          style={{ width: "100%" }}
          filter={true}
          filterBy="label"
          filterPlaceholder="Search"
          onChange={e => this.setValue("name", e.value)}
        />
      );
    } else {
      return (
        <pr.InputText
          style={{ width: "100%" }}
          placeholder={"Value"}
          value={this.state.currentListProperty.name || ""}
          onChange={e => this.setValue("name", e.target.value)}
        />
      );
    }
  };

  setValue = async (field, value) => {
    if (this.props.capitalize) {
      await this.setState(prevState => ({
        currentListProperty: {
          // object that we want to update
          ...prevState.currentListProperty, // keep all other key-value pairs
          [field]: value.toUpperCase()
        }
      }));
    } else {
      await this.setState(prevState => ({
        currentListProperty: {
          // object that we want to update
          ...prevState.currentListProperty, // keep all other key-value pairs
          [field]: value
        }
      }));
    }
  };
  getCustomValues = () => {
    let componentArray = [];
    let i = 0;

    // var totalNumberOfAttributes = temporaryAttributSet1.length;
    // var splitInto = 0;
    // var uigno = 0;
    // if (totalNumberOfAttributes % 3 === 0) {
    //   splitInto = 3;
    //   uigno = 4;
    // } else {
    //   splitInto = 2;
    //   uigno = 6;
    // }

    if (this.props.listProperties !== undefined) {
      this.logger.info(this.props.listProperties);
      var array = this.props.listProperties;
      array.forEach(e => {
        componentArray[i] = (
          <div className="ui-g-4 card" key={i} style={{ paddingTop: "2em" }}>
            <div>
              <label style={{ float: "middle" }}>
                {this.props.propertyPrefix} {e}
              </label>
              {this.props.defaults === true &&
              (i === 0 || i === array.length - 1) ? (
                <label></label>
              ) : (
                <pr.Button
                  align="right"
                  icon="pi pi-times"
                  className="p-button-danger"
                  style={{ float: "right" }}
                  onClick={() => {
                    this.removeAcceptedProperty(e);
                  }}
                />
              )}
            </div>
          </div>
        );

        i++;
      });
    }

    return componentArray;
  };
  getCustomValuesTable = () => {
    if (Format.isNotNull(this.props.defaultValues)) {
      if (Format.isNotNull(this.props.listProperties)) {
      } else {
        this.props.updateBean(this.props.listField, this.props.defaultValues);
      }
    }
    if (this.props.listProperties !== undefined) {
      return (
        <div className="ui-g-12" style={{ paddingTop: "2em" }}>
          <pr.DataTable
            ref={el => {
              this.dt = el;
            }}
            reorderableColumns={false}
            selectionMode="single"
            onSelectionChange={e => {}}
            value={this.props.listProperties}
            dataKey="id"
            emptyMessage="No Properties"
            // header={
            //   <div>
            //     <label className="header-label">Accepted Values</label>
            //   </div>
            // }
            rows={100}
            autoLayout={true}
          >
            <pr.Column
              header="Value"
              body={this.nameValueTemplate}
              style={{ overflow: "auto", background: "white" }}
            />
            <pr.Column
              header="Quantity"
              body={this.quantityValueTemplate}
              style={{ overflow: "auto", background: "white" }}
            />
            <pr.Column
              key="add"
              body={this.getPropertyRemoveTemplate}
              style={{ textAlign: "center", background: "white", width: "8em" }}
            />
          </pr.DataTable>{" "}
        </div>
      );
    } else {
      return <div></div>;
    }
  };

  nameValueTemplate = (rowData, column) => {
    return <label style={{ float: "middle" }}> {rowData.name} </label>;
  };
  quantityValueTemplate = (rowData, column) => {
    return <label style={{ float: "middle" }}> {rowData.quantity} </label>;
  };
  getPropertyRemoveTemplate = (rowData, column) => {
    if (Format.isNotNull(this.props.defaultValues)) {
      if (this.props.defaultValues.includes(rowData)) {
        return <div></div>;
      }
    }

    return (
      <div>
        <pr.Button
          align="right"
          icon="pi pi-times"
          className="p-button-danger"
          style={{ background: "red" }}
          onClick={() => {
            this.removeAcceptedProperty(rowData);
          }}
        />
      </div>
    );
  };
}
// TODO dropdown fix
// addAcceptedProperty = () => {
//     var property = this.state.currentAcceptedProperty;
//     var currentList = this.state.editedAttributeSet.attributeIdList;
//     if (currentList === undefined || currentList === null) {
//       currentList = [];
//     }

//     currentList.push(property);
//     this.logger.info(currentList);
//     this.updateBean("attributeIdList", currentList);
//     this.setState({ currentAcceptedProperty: "" });
//     var newAttributes = [];
//     var attributes = this.state.attributeOptions;
//     var removedAttributeOptions = this.state.removedAttributeOptions;
//     if (
//       removedAttributeOptions === undefined ||
//       removedAttributeOptions === null
//     ) {
//       removedAttributeOptions = [];
//     }
//     this.logger.info(property);
//     this.logger.info(attributes);
//     attributes.forEach(e => {
//       if (e.value === property) {
//         removedAttributeOptions.push(e);
//       } else {
//         newAttributes.push(e);
//       }
//     });

//     this.setState({ attributeOptions: newAttributes });
//   };
//   removeAcceptedProperty = value => {
//     var currentList = this.state.editedAttributeSet.attributeIdList;
//     this.logger.info(currentList);
//     if (currentList === undefined || currentList === null) {
//       currentList = [];
//     } else {
//       this.logger.info(value);
//       currentList = currentList.filter(item => item !== value);
//     }
//     var currentAttributes = this.state.attributeOptions;
//     if (currentAttributes === undefined || currentAttributes === null) {
//       currentAttributes = [];
//     }
//     var removedAttributes = this.state.removedAttributeOptions;
//     if (removedAttributes === undefined || removedAttributes === null) {
//       removedAttributes = [];
//     }
//     var newRemovedAttributes = [];
//     removedAttributes.forEach(e => {
//       if (e.value === value) {
//         currentAttributes.push(e);
//       } else {
//         newRemovedAttributes.push(e);
//       }
//     });

//     this.logger.info(currentList);
//     this.updateBean("attributeIdList", currentList);
//     this.setState({ currentAcceptedProperty: "" });

//     this.setState({ attributeOptions: currentAttributes });
//     this.setState({ removedAttributeOptions: newRemovedAttributes });
//   };



// WEBPACK FOOTER //
// ./src/components/Common/BPMPartProductJson.js